import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ten: undefined, // required, minLength: 1 - Tên dòng họ
  // optional - Thông tin địa chỉ
  dia_chi: {
    quoc_gia_id: undefined, // optional, ref: quoc_gia - Mã quốc gia
    tinh_id: undefined, // optional, ref: province - Mã tỉnh
    huyen_id: undefined, // optional, ref: district - Mã huyện
    xa_id: undefined, // optional, ref: commune - Mã xã
    dia_chi: undefined, // optional - Địa chỉ chi tiết
  },
  // optional - Khoảng đinh (độ lớn của một dòng họ - là số lượng con trai)
  khoang_dinh: {
    tu: undefined, // optional, gt: 0 - Từ
    den: undefined, // optional, gt: 0 - Đến
  },
  ngay_gio_to: undefined, // optional - Ngày giỗ tổ
  dia_chi_mo_to: undefined, // optional - Địa chỉ mộ tổ
  nguoi_quan_lys: [
    // optional - Danh sách thông tin người quản lý
    {
      nguoi_dung_id: undefined, // required, ref: nguoi_dung - Mã người quản lý
      dien_thoai: undefined, // required - Số điện thoại người quản lý
      quyen: undefined, // required, enum(FamilyAdmin, FamilyModerator) - Quyền hạn
      nhanh_ids: [], // optional, array items: required - Danh sách node mà có quyền quản trị dữ liệu (Dành cho quyền FamilyModerator)
      quyen_duyet: undefined, // optional - Có quyền phê duyệt thông tin chỉnh sửa node gửi lên hay không (Dành cho quyền FamilyModerator)
    },
  ],
  lich_su: undefined, // optional - Lịch sử dòng họ
  lich_su_file_id: undefined, // optional, ref: mushroom_file - File lịch sử dòng họ
  dai_ly_id: undefined, // optional, ref: agt_dai_ly - Mã đại lý
  hieu_luc: undefined, // required - Có hiệu lực không
  trang_thai: undefined, // required, enum(chua_thanh_toan, dang_hoat_dong, sap_het_han, cho_gia_han) - Trạng thái
  // optional - Gói dịch vụ
  goi_dich_vu: {
    goi_dich_vu_id: undefined, // optional, ref: prd_goi_dich_vu - Id gói dịch vụ
    ten_goi: undefined, // optional - Tên gói dịch vụ
  },
  thue_bao_id: undefined, // optional, ref: thue_bao - Thuê bao hiện tại
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
  // optional - Các thông tin của dòng họ được tổng hợp từ các nguồn khác (với mục đích lưu trữ và truy cập nhanh)
  thong_tin_tong_hop: {
    // optional - Thông tin về dung lượng lưu trữ của dòng họ. Cập nhật hàng ngày
    dung_luong_luu_tru: {
      han_muc: undefined, // optional - Hạn mức lưu trữ của dòng họ, đơn vị: byte. Null nghĩa là không giới hạn. Giá trị này được cập nhật khi khởi tạo, nâng cấp, gia hạn gói
      gia_tri: undefined, // optional - Dung lượng lưu trữ hiện tại của dòng họ, đơn vị: byte. Giá trị này được cập nhật hàng ngày
      so_luong_file: undefined, // optional - Số lượng file lưu trữ. Giá trị này được cập nhật hàng ngày
    },
  },
};

// validation form
model.validForm = {
  ten: [ValidService.required],
};

model.khoangDinh = [
  { value: 1, label: "Dưới 100 đinh" },
  { value: 100, label: "Từ 100 đến 200 đinh" },
  { value: 200, label: "Từ 200 đến 300 đinh" },
  { value: 300, label: "Từ 300 đến 500 đinh" },
  { value: 500, label: "Từ 500 đến 1000 đinh" },
  { value: 1000, label: "Từ 1000 đến 3000 đinh" },
  { value: 3001, label: "Trên 3000 đinh" },
];
model.hieuLuc = [
  { value: "true", label: "Hiệu lực" },
  { value: "false", label: "Hết hiệu lực" },
];
model.trangThai = [
  { value: "chua_thanh_toan", label: "Chưa thanh toán" },
  { value: "dang_hoat_dong", label: "Đang hoạt động" },
  { value: "sap_het_han", label: "Sắp hết hạn" },
  { value: "cho_gia_han", label: "Chờ gia hạn" },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  fields:
    "id,ten,dia_chi,khoang_dinh,ngay_gio_to,dia_chi_mo_to,nguoi_quan_lys,lich_su,lich_su_file_id,dai_ly_id,dai_ly_khoi_tao_id,hieu_luc,trang_thai,goi_dich_vu,thue_bao_id,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id,thong_tin_tong_hop",
  recordSelected: [],

  dataSearch: {
    value: {
      ten: "",
      "dia_chi.dia_chi": "",
      "khoang_dinh.den": "",
      dai_ly_id: "",
      "nguoi_quan_lys.dien_thoai": "",
      "goi_dich_vu.goi_dich_vu_id": "",
      trang_thai: "",
    },
    valid: {
      ten: [],
      thoi_diem_tao: [],
    },
    operator: {
      ten: ":regex_i:",
      "dia_chi.dia_chi": ":regex_i:",
      "nguoi_quan_lys.dien_thoai": ":regex_i:",
      "goi_dich_vu.goi_dich_vu_id": "",
      "khoang_dinh.den": "",
      dai_ly_id: "",
      trang_thai: "",
    },
  },
};

export default model;
